import { SettingsPermissions } from "../../permissions";
import type {
  SettingAccess,
  SettingAgentEditability,
  SettingGroupDefinition,
  SettingOwner,
  SettingPermission,
  SettingRisk,
} from "../../settings-catalog/types";

export type CustomerWidgetFlatTeamSettingGroupId = "customer_widget.appearance";

const customerWidgetSettingsOwner: SettingOwner = {
  kind: "teamSettings",
  path: "settings.customerWidget",
  product: "customer-widget",
};

const mediumCustomerFacingRisk: SettingRisk = {
  level: "medium",
  reason: "Changes can affect customer-visible storefront widget experiences.",
};

const requiresApproval: SettingAgentEditability = { mode: "requiresApproval" };

function directMerchantAccess(permission: SettingPermission): SettingAccess {
  return {
    read: { minVisibility: "merchant" },
    write: {
      mode: "grants",
      grants: [{ minVisibility: "merchant", method: "direct", permission }],
    },
  };
}

export const CustomerWidgetFlatTeamSettingGroups = [
  {
    id: "customer_widget.appearance",
    title: "Customer Widget Appearance",
    description:
      "Storefront customer widget branding, colors, launcher placement, text, logo, and sizing.",
    productArea: "customer-widget",
    access: directMerchantAccess(SettingsPermissions.SET_GENERAL_SETTINGS),
    owner: customerWidgetSettingsOwner,
    risk: mediumCustomerFacingRisk,
    agentEditability: requiresApproval,
    fullPageTarget: { type: "settings", path: "customer-widget?tab=general" },
    synonyms: [
      "storefront customer widget",
      "chat widget appearance",
      "chat widget colors",
      "colors chat widget",
      "change chat widget colors",
      "support widget appearance",
      "widget branding",
      "widget colors",
      "launcher placement",
    ],
    changeGuidance: {
      summary:
        "Use focused setting ids for specific appearance changes such as colors, placement, text, logo, or font size.",
    },
  },
] as const satisfies readonly SettingGroupDefinition<CustomerWidgetFlatTeamSettingGroupId>[];

export const CustomerWidgetFlatTeamSettingGroupById: Record<
  CustomerWidgetFlatTeamSettingGroupId,
  SettingGroupDefinition<CustomerWidgetFlatTeamSettingGroupId>
> = { "customer_widget.appearance": CustomerWidgetFlatTeamSettingGroups[0] };
